
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MyProfileActions } from '../actions/index';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { RequestAccessObj } from '../my-profile-state';
import { MyProfileService } from '../../services/my-profile.service';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()
export class RequestAccessEffects {

  constructor(
    private actions$: Actions,
    private readonly apiService: ApiService,
    private globalService: GlobalService,
    private myProfileService: MyProfileService,
  ) { }

  protected logger = inject(LoggerService);

  UpdateRequestAccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyProfileActions.submitRequestAccess),
      switchMap((action) => {
        let tableData: RequestAccessObj[];
        this.myProfileService.getUpdateTableState().subscribe(data => tableData = data);
        return this.apiService.updateAccessRequest(tableData, action.comment)
      }),
      map(() => {
        this.globalService.loadingSubject.next(false);
        return MyProfileActions.submitRequestAccessSuccess();
      }),
      catchError((error) =>
        of(MyProfileActions.submitRequestAccessFail({ payload: tryNormalizeHttpError(error, this.logger) }))
      )
    )
  );

}